"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.parse-int");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/* tslint:disable */


exports["default"] = function (_a) {
  var _b = _a.width,
      width = _b === void 0 ? '32px' : _b,
      _c = _a.height,
      height = _c === void 0 ? '32px' : _c,
      _d = _a.color,
      color = _d === void 0 ? '#000' : _d,
      _e = _a.bgColor,
      bgColor = _e === void 0 ? '#FFF' : _e,
      rest = __rest(_a, ["width", "height", "color", "bgColor"]);

  return react_1["default"].createElement("svg", __assign({}, rest, {
    width: width,
    height: height,
    viewBox: "0 0 " + Number.parseInt(width) + " " + Number.parseInt(height)
  }), react_1["default"].createElement("g", {
    stroke: 'none',
    fill: 'none',
    strokeWidth: '1',
    fillRule: 'evenodd'
  }, react_1["default"].createElement("g", {
    transform: 'translate(-672.000000, -2147.000000)',
    fill: '#FFFFFF'
  }, react_1["default"].createElement("g", {
    transform: 'translate(48.000000, 1160.000000)'
  }, react_1["default"].createElement("g", {
    transform: 'translate(624.000000, 867.000000)'
  }, react_1["default"].createElement("g", {
    transform: 'translate(0.000000, 120.000000)'
  }, react_1["default"].createElement("path", {
    d: 'M0.0658530871,9.87815446 C-0.653078882,3.75980868 4.74122642,0.281587436 5.22149916,0.161345723 C5.58173965,0.0411918938 6.18056751,-0.678189109 8.5790967,2.32098276 C10.8574978,5.32015463 12.5355381,7.7186772 11.0961171,9.03853973 C9.53820497,10.3586819 7.25976392,12.0377116 8.45900856,14.3175904 C9.4180769,16.3571055 15.653119,22.475651 17.5710161,23.4351879 C19.9695054,24.6351682 21.5274575,22.3553694 22.8468302,20.9166233 C24.166163,19.3577555 26.6831834,21.0367772 29.6804367,23.316584 C32.6777698,25.7165447 31.9588378,26.3157559 31.8387497,26.7948053 C31.7186695,27.1552668 28.2425727,32.5528246 22.0077303,31.9536134 C15.5342285,31.2342412 0.667731051,16.3585436 0.0688872291,9.88107062 L0.0658530871,9.87815446 Z'
  })))))));
};
/* tslint:enable */